<template>
  <div class="mymodal-view" v-if="show">
    <div class="mymodal-box" :style="styles">
      <div class="mymodalcontent" :style="innerstyles">
        <h4>
          {{ headerText }}
        </h4>
        <p v-if="mainText">mainText</p>
        <slot v-else></slot>
      </div>
      <div v-if="buttons" class="mymodalfooter">
        <a
          href="#!"
          class="waves-effect"
          v-for="button in buttons"
          :key="button.name"
          :class="button.class || 'btn-flat'"
          :style="button.style || ''"
          @click.prevent="button.funq"
          >{{ button.name }}</a
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
.mymodal-view {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
.mymodal-view .mymodal-box {
  border-radius: 2px;

  margin-left: auto;
  margin-right: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background-color: white;
  opacity: 1;
  max-height: 80vh;
}
.mymodal-view .mymodalcontent {
  padding: 24px;
}
.mymodal-view .mymodalcontent h4 {
  margin-top: 0;
}
.mymodal-view .mymodalfooter {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0 0 2px 2px;
  background-color: #fafafa;
  padding: 4px 6px;
  height: 56px;
  width: 100%;
  text-align: right;
}
</style>
<script>
export default {
  props: [
    "show",
    "headerText",
    "mainText",
    "html",
    "buttons",
    "styles",
    "innerstyles",
  ],
  mounted() {},
};
</script>
